module.exports = __webpack_public_path__ + "img/tapuah_no.a7f2f869.png";